import { Drawer } from '@/components';
import type { ComponentProps, FC } from 'react';
import { useDrawerState } from '../DrawerStateProvider';
import { MasterTableEditWarning } from '../MasterTableEditWarning';
import { RevenueNatureForm } from './RevenueNatureForm';

type Props = ComponentProps<typeof RevenueNatureForm>;

export const RevenueNatureFormDrawer: FC<Props> = ({
  type,
  initialValues,
  onSubmit,
}) => {
  const { drawerState, setDrawerState } = useDrawerState();

  return (
    <Drawer
      open={drawerState.open && drawerState.type === 'revenue-nature'}
      onClose={() => {
        setDrawerState({ open: false });
      }}
      destroyOnClose
    >
      {type === 'edit' && <MasterTableEditWarning marginBottom={8} />}
      <RevenueNatureForm
        type={type}
        initialValues={initialValues}
        onSubmit={onSubmit}
      />
    </Drawer>
  );
};
